import getPanAndZoom from './getPanAndZoom';

/**
 * Returns the CSS transform that needs to be applied to the
 * document layer in order to pan the background grid.
 */
export default function getDocumentLayerStyle() {
    const { x, y, zoom } = getPanAndZoom();
    const gridSize = 50 * zoom;
    return {
        backgroundPosition: `${x}px ${y}px`,
        backgroundSize: `${gridSize}px ${gridSize}px`,
    };
}
